import { ReactElement } from 'react';
import { Price } from '@client/product/components/ProductData/PriceList/Price';
import { Props } from '@client/product/components/ProductData/PriceList/SecondaryPrices';

export const SecondaryPrices = ({ prices }: Props): ReactElement | null => {
  if (prices.listPriceWithoutVat) {
    return (
      <div className='PriceList-SecondaryPrices'>
        <Price
          price={prices.listPriceWithoutVat.price}
          tax={prices.listPriceWithoutVat.tax}
          dataAttributes={{ 'data-testid': 'pdpSRPExclVAT' }}
          isSecondary
          className='PriceList-SecondaryPrice'
        />
      </div>
    );
  }

  return null;
};
